import Repository from "./repository"

const resource = 'operators'

export default {
    async add(payload) {
        let endpoint = `${resource}`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async get({ id }) {
        let endpoint = `${resource}/${id}`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async update(payload) {
        let endpoint = `${resource}/${payload.id}`;
        let response = await Repository.put(endpoint, payload);
        return response;
    },
    async getSkills() {
        let endpoint = `${resource}/skills`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async getPagedOnlineOperators({ page, take, search, status, skill }) {
        page = page === undefined ? 1 : page;
        take = take === undefined ? 10 : take;
        let endpoint = `${resource}/online/paged?page=${page}&take=${take}`;
        if (search !== undefined && search !== null && search !== '') {
            endpoint += `&search=${search}`;
        }
        if (status !== undefined && status !== null && status !== '') {
            endpoint += `&status=${status}`;
        }
        if (skill !== undefined && skill !== null && skill !== '') {
            endpoint += `&skill=${skill}`;
        }
        let response = await Repository.get(endpoint);
        return response
    },
    async kpi() {
        let endpoint = `${resource}/kpi`;
        let response = await Repository.get(endpoint);
        return response;
    },
    async notifyJoinPreRoom(payload) {
        let endpoint = `${resource}/join-pre-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyLeavePreRoom(payload) {
        let endpoint = `${resource}/leave-pre-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyJoinRoom(payload) {
        let endpoint = `${resource}/join-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyLeaveRoom(payload) {
        let endpoint = `${resource}/leave-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    }
}